import React, { createContext, FC, useContext, useState } from 'react';
import { IBusiness, InitialBusiness } from '../utils/utils';
import { Operation, Resource } from '../../../common/constants';
import { IUserContext, UserContext } from '../../../providers/UserProvider';

interface BusinessContextType {
  businessState: IBusiness;
  setBusinessState: React.Dispatch<React.SetStateAction<IBusiness>>;
  canEditBusiness: Boolean;
}

export const BusinessContext = createContext<BusinessContextType>({
  businessState: InitialBusiness,
  canEditBusiness: false,
  setBusinessState: () => {},
});

interface Props {}

export const BusinessProvider: FC<Props> = (props) => {
  const [businessState, setBusinessState] = useState<IBusiness>(
    InitialBusiness,
  );
  const { canI } = useContext<IUserContext>(UserContext);
  const canEditBusiness = canI(Operation.UPDATE, Resource.BUSINESSES);
  return (
    <BusinessContext.Provider
      value={{
        businessState,
        setBusinessState,
        canEditBusiness,
      }}>
      {props.children}
    </BusinessContext.Provider>
  );
};
